export const PROGAI_EMAIL = 'sales@getprog.ai';
